import * as _ from 'underscore';

import { FlowOutputStepRunListItemInfo, FlowOutputStepRunType } from '../models/FlowOutputStepRunInfo';
import { FlowOutputStep } from '../ServerApi/types/FlowOutputStep';
import { FlowOutputStepRun } from '../ServerApi/types/FlowOutputStepRun';
import { FlowRun, FlowRunTriggerType } from '../ServerApi/types/FlowRun';
import { FlowRunErrorUniqueKey } from '../ServerApi/types/FlowRunError';
import { MapperHelper } from './MapperHelper';

export module FlowOutputStepRunMapper {

  export function map(
    steps: FlowOutputStepRun[],
    outputs: _.Dictionary<FlowOutputStep>,
    runs: _.Dictionary<FlowRun>,
  ): FlowOutputStepRunListItemInfo[] {
    return _.map(steps, (s: FlowOutputStepRun) => mapOne(s, outputs, runs));
  }

  export function mapOneForAlert(
    s: FlowOutputStepRun,
    outputs: _.Dictionary<FlowOutputStep>,
  ): FlowOutputStepRunListItemInfo {
    return {
      id: s.id,
      flowId: s.flowId,
      startedAt: MapperHelper.toDate(s.startedAt),
      completedAt: MapperHelper.toDate(s.completedAt),
      status: s.status,
      rowsProduced: s.rowsProduced >= 0 ? s.rowsProduced : 0,
      flowRunId: s.flowRunId,
      flowOutputStepId: s.flowOutputStepId,
      outputName: outputs[s.flowOutputStepId] != null ? outputs[s.flowOutputStepId].name : '',
      runType: FlowOutputStepRunType.unknown,
      publishedDataSourceId: s.publishedDataSourceId,
      publishedDataSourceName: s.publishedDataSourceName,
      flowRunErrors: s.errors ? _.uniq(s.errors, false, FlowRunErrorUniqueKey) : [],
      isIncremental: s.isIncremental,
    };
  }

  export function mapOne(
    s: FlowOutputStepRun,
    outputs: _.Dictionary<FlowOutputStep>,
    runs: _.Dictionary<FlowRun>,
  ): FlowOutputStepRunListItemInfo {
    const triggerType = runs[s.flowRunId] != null ? runs[s.flowRunId].triggerType : null;
    const runType = triggerType != null && triggerType === FlowRunTriggerType.adhoc ?
      FlowOutputStepRunType.ondemand :
      triggerType != null && triggerType === FlowRunTriggerType.scheduled ?
        FlowOutputStepRunType.scheduled :
        FlowOutputStepRunType.unknown;

    return {
      id: s.id,
      flowId: s.flowId,
      startedAt: MapperHelper.toDate(s.startedAt),
      completedAt: MapperHelper.toDate(s.completedAt),
      status: s.status,
      rowsProduced: s.rowsProduced >= 0 ? s.rowsProduced : 0,
      flowRunId: s.flowRunId,
      flowOutputStepId: s.flowOutputStepId,
      outputName: outputs[s.flowOutputStepId] != null ? outputs[s.flowOutputStepId].name : '',
      runType: runType,
      publishedDataSourceId: s.publishedDataSourceId,
      publishedDataSourceName: s.publishedDataSourceName,
      flowRunErrors: s.errors ? _.uniq(s.errors, false, FlowRunErrorUniqueKey) : [],
      isIncremental: s.isIncremental,
    };
  }
}
